import { AccountStats } from "@/services/account.service";
import { routes } from "@/services/account.service";
import useSWR from "swr";
import { fetcherV2 } from "@gogive/services";

interface Props {
  startDate?: Date;
  endDate?: Date;
  campaignId?: number;
  fundraisingCampaignId?: string;
}
export function useAccountStats(query: Props) {
  const { data, error } = useSWR(
    () => [routes.getStats, query, true],
    fetcherV2<AccountStats>,
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      suspense: false,
      shouldRetryOnError: false,
    }
  );

  return {
    accountStats: data,
    isLoading: !error && !data,
    isError: error,
  };
}
